<section class="hero">
  <div class="hero-inner">
    <h1>Die Mission von Rast-WC.de</h1>
    <p class="subtitle">Deine Suche nach sauberen Raststätten-Toiletten hat ein Ende. Von Reisenden für Reisende.</p>
  </div>
</section>

<div class="content-wrapper">
  <section class="container">
    <mat-card class="intro">
      <mat-card-content>
        <p>
          Kennst du das Gefühl? Unterwegs auf der Autobahn, die nächste Pause ist dringend nötig, aber die Frage bleibt:
          Ist das nächste <strong>Autobahn WC</strong> sauber und sicher? Rast-WC.de ist die Antwort. Unsere Community
          teilt <strong>aktuelle Bewertungen, Fotos und Hinweise</strong>, damit du in Sekunden die beste Entscheidung
          für deine Pause triffst.
        </p>
        <p>
          Wir sind die transparente <strong>Sanifair Alternative</strong> für deine Reiseplanung. Mit Filtern für
          <em>Sauberkeit</em>, <em>kostenlose Nutzung</em>, <em>Barrierefreiheit</em>, <em>Wickelräume</em>,
          <em>Duschen</em> und mehr findest du garantiert den perfekten Stopp für deine Bedürfnisse.
        </p>
      </mat-card-content>
    </mat-card>

    <div class="feature-grid">
      <mat-card class="feature">
        <mat-card-header>
          <mat-icon>star</mat-icon>
          <div class="title">Echte Bewertungen</div>
        </mat-card-header>
        <mat-card-content>
          Vertraue auf <strong>echte Erfahrungen</strong> von Fahrerinnen und Fahrern – mit ehrlichen Kommentaren.
        </mat-card-content>
      </mat-card>

      <mat-card class="feature">
        <mat-card-header>
          <mat-icon>tune</mat-icon>
          <div class="title">Smarte Filter</div>
        </mat-card-header>
        <mat-card-content>
          Filtere nach <strong>Sauberkeit, Kosten und Ausstattung</strong>, damit du ohne Umwege die ideale Raststätte
          findest.
        </mat-card-content>
      </mat-card>

      <mat-card class="feature">
        <mat-card-header>
          <mat-icon>map</mat-icon>
          <div class="title">Interaktive Karte</div>
        </mat-card-header>
        <mat-card-content>
          Alle Raststätten auf einen Blick, inklusive <strong>Fotos, Öffnungszeiten und Preisen</strong>.
        </mat-card-content>
      </mat-card>

      <mat-card class="feature">
        <mat-card-header>
          <mat-icon>favorite</mat-icon>
          <div class="title">Deine Favoriten</div>
        </mat-card-header>
        <mat-card-content>
          Speichere deine besten Stopps als <strong>Favoriten</strong> und plane deine zukünftigen Fahrten noch
          schneller.
        </mat-card-content>
      </mat-card>
    </div>

    <mat-card class="mission">
      <mat-card-header>
        <mat-icon>flag</mat-icon>
        <div class="title">Unsere Vision</div>
      </mat-card-header>
      <mat-card-content>
        <p>
          Wir wollen, dass <strong>saubere, sichere und zugängliche Sanitärpausen</strong> auf Deutschlands Autobahnen
          eine Selbstverständlichkeit sind. Durch die Kraft der Community schaffen wir eine verlässliche und aktuelle
          Datenbasis für eine entspanntere Reise.
        </p>
      </mat-card-content>
    </mat-card>

    <mat-card class="trust">
      <mat-card-header>
        <mat-icon>verified</mat-icon>
        <div class="title">Transparenz & Qualität</div>
      </mat-card-header>
      <mat-card-content>
        <ul>
          <li><strong>Geprüfte Inhalte:</strong> Jede Meldung wird geprüft, um die Datenqualität hochzuhalten.</li>
          <li
            ><strong>Immer aktuell:</strong> Hinweise zu <em>Gebühren</em> und <em>Ausstattung</em> werden fortlaufend
            erneuert.</li
          >
          <li><strong>Dein Datenschutz:</strong> Wir gehen maximal sparsam mit deinen Daten um. Versprochen.</li>
        </ul>
      </mat-card-content>
    </mat-card>

    <mat-card class="faq">
      <mat-card-header>
        <mat-icon>help</mat-icon>
        <div class="title">Häufige Fragen (FAQ)</div>
      </mat-card-header>
      <mat-card-content>
        <h3>Was genau ist Rast-WC.de?</h3>
        <p
          >Eine von der Community getragene Plattform, die dir hilft,
          <strong>die besten Toiletten an deutschen Raststätten</strong> zu finden.</p
        >

        <h3>Wie kann ich mitmachen?</h3>
        <p
          >Bewerte Orte, lade Fotos hoch oder korrigiere Informationen –
          <strong>jede einzelne Rückmeldung zählt</strong> und hilft anderen Reisenden.</p
        >

        <h3>Ist die Nutzung von Rast-WC.de kostenlos?</h3>
        <p
          >Ja, die Plattform ist und bleibt <strong>kostenlos</strong>. Eventuelle Gebühren vor Ort zeigen wir dir
          transparent an, wenn sie uns bekannt sind.</p
        >
      </mat-card-content>
    </mat-card>

    <div class="cta">
      <a class="cta-button" routerLink="/" aria-label="Zur interaktiven Karte">
        <mat-icon>near_me</mat-icon>
        Zur interaktiven Karte
      </a>
    </div>
  </section>
</div>
